// @flow

import { fetch } from 'whatwg-fetch'

function _handleNewsLetterSubmit (emailAddress) {
  return fetch(`${window.origin}/index.php?eID=newsletter`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: emailAddress,
    }),
  })
}

export default function SubscribeNewsLetter () {
  const newsletterFormElement = Array.prototype.slice.call(document.querySelectorAll('.subscribe-newsletter'))

  newsletterFormElement.forEach(formElement => {
    formElement.addEventListener('submit', (event) => {
      event.preventDefault()

      const input = document.querySelector('.newsletter-input')

      if (!/.+@.+\..+/.test(input.value)) {
        input.classList.add('invalid')

        return
      }

      input.classList.remove('invalid')

      const newsletter = document.querySelector('input[name=\'newsletter\']')
      const privacy = document.querySelector('input[name=\'privacy\']')

      if (!newsletter.checked || !privacy.checked) {
        if (!newsletter.checked) {
          newsletter.classList.add('error')
        }
        if (!privacy.checked) {
          privacy.classList.add('error')
        }

        return
      }

      _handleNewsLetterSubmit(formElement.email.value)
        .then(response => response.json())
        .then(response => {
          const resultContainer = formElement.querySelector('.newsletter-response-container')
          if (response.status === 'OK') {
            resultContainer.innerHTML = formElement.dataset.successMessage
          }
          else {
            let errorMessage = response?.message?.split('Detail: ')
            errorMessage = errorMessage ? JSON.parse(errorMessage[1]) : errorMessage
            if (errorMessage.status && errorMessage.status === 409) {
              // eslint-disable-next-line max-len
              resultContainer.insertAdjacentHTML('beforeend', `<div id="newsletter-error">${formElement.dataset.errorAlreadyExists}</div>`)
            }
            else if (!document.querySelector('#newsletter-error')) {
              // eslint-disable-next-line max-len
              resultContainer.insertAdjacentHTML('beforeend', `<div id="newsletter-error">${formElement.dataset.errorMessage}</div>`)
            }
          }
        })
    })
  })
}
